//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vuex from "vuex";
import pic1 from '../../assets/images/pic_up_preview_szf_1.png';
import pic2 from '../../assets/images/pic_up_preview_szf_2.png';
import pic3 from '../../assets/images/pic_up_preview_szf_3.png';
import UploadImage from "@/views/register/upload_image.vue";
import {
    commonVerifyPersonalField,
    defaultPersonalVerifyForm,
    commonVerifyCompanyField,
    defaultCompanyVerifyForm,
    localStorageKeys,
    applyFields, isEmptyForm,
} from "./constatns";
import lodash from 'lodash';
export default {
    props: [],
    data() {
        return {
            storeLoaded: false,
            updateOnly: oofUtil.getQueryParamByKey('update_only') == 1,
            pvImg: {
                pic1,
                pic2,
                pic3,
            },
            postForm: {},
            verifyType: 1, // 1-企业，2-个人
        };
    },
    computed: {
        formFields() {
            if (this.verifyType == 2) {
                return commonVerifyPersonalField;
            }
            return commonVerifyCompanyField;
        },
        applyStatus() {
            return lodash.get(this.openPlatformStatus, 'status', 0);  // 0-未知； 1-企业 2-个人
        },
        selectorValue() {
            return function (opt, val) {
                const options = opt.options || [];
                const item = options.find(i => i.value == val);
                if (item) return item.label;
                return val;
            }
        },
        isLongTerm() {
            return this.postForm.cert_expired_at == 1;
        },
        ...Vuex.mapState(['openPlatformStatus', 'verifyInfo'])
    },
    methods: {
        ...Vuex.mapMutations(['setOpenPlatformStatus']),
        configLongTerm(){
            this.postForm.cert_expired_at = this.postForm.cert_expired_at == 1 ? '' : 1;
        },
        validateForm() {
            return this.formFields.reduce((ans, item) => {
                if (!ans) return ans;
                if (item.required) {
                    if (item.onValidate) {
                        const msg = item.onValidate(this.postForm);
                        if (msg) {
                            $.alertTip(msg);
                            return ans && false;
                        }
                    } else {
                        if (!this.postForm[item.key]) {
                            $.alertTip(`${item.label}为空`);
                            return ans && false;
                        }
                    }
                    return ans;
                } else {
                    return ans;
                }
            }, true)
        },
        submit() {
            const ret = this.validateForm()
            if (!ret) return;
            // 提交表单
            let postData = {};
            this.formFields.forEach((item) => {
                if (item.onValue) {
                    postData = {
                        ...postData,
                        ...item.onValue(this.postForm),
                    }
                } else {
                    postData[item.key] = this.postForm[item.key];
                }
            });
            // 仅认证
            if (this.updateOnly) {
                this.submitVerify(postData,  this.openPlatformStatus.apply_id);
                return;
            }
            this.submitApply((r, apply_id) => {
                if(r) {
                    this.setOpenPlatformStatus({
                        ...this.openPlatformStatus,
                        apply_id: apply_id,
                    })
                    this.submitVerify(postData, apply_id || this.openPlatformStatus.apply_id);
                }
            })
        },
        loadApplyFormLocal() {
            const formRaw = localStorage.getItem(localStorageKeys.applyForm) || '';
            if (!formRaw) return null;
            try {
               return JSON.parse(formRaw);
            } catch (e){}
            return null;
        },
        submitApply(callback) {
            const fd = this.loadApplyFormLocal();
            if (!fd || this.openPlatformStatus.status == 5) {
                callback && callback(true, this.openPlatformStatus.apply_id)
                return;
            }
            const postForm = lodash.pick(fd, applyFields[this.verifyType] || []);
            const url = this.verifyType == 1 ? 'user/applyCorpDev' : 'user/applyPersonalDev'
            this.$api({
                url: `//passportapi.115.com/app/1.0/web/1.0/${url}` ,
                method: 'post',
                data: postForm
            }).then(data => {
                if(data.state) {
                    callback(true, lodash.get(data,'data.apply_id'))
                    localStorage.removeItem(localStorageKeys.applyForm);
                } else {
                    $.alertTip(data.message);
                    callback(false, 0)
                }
            }).catch(e => {
                callback(false, 0)
                $.alertTip(e.message || '网络异常，请重试')
            })
        },
        submitVerify(postData, apply_id) {
            const url = this.verifyType == 1 ? 'user/applyCorpCert' : 'user/applyPersonalCert'
            this.$api({
                url: `//passportapi.115.com/app/1.0/web/1.0/${url}` ,
                method: 'post',
                data: {
                    ...postData,
                    apply_id,
                }
            }).then(data => {
                if(data.state) {
                    localStorage.removeItem(`${localStorageKeys.verifyForm}:${this.verifyType}`);
                    localStorage.removeItem(localStorageKeys.verifyType);
                    this.$router.push({
                        name: 'register_done',
                        query: {
                            update_only: this.updateOnly ? undefined : '1'
                        }
                    })
                } else {
                    $.alertTip(data.message);
                }
            }).catch(e => {
                $.alertTip(e.message || '网络异常，请重试')
            })
        },
        pickVerifyData() {
            let formData = {};
            if (this.verifyInfo) {
                const field = this.verifyType == 2 ? commonVerifyPersonalField : commonVerifyCompanyField;
                field.forEach(item => {
                    if (item.onRestore) {
                        formData = {
                            ...formData,
                            ...item.onRestore(this.verifyInfo)
                        };
                    } else {
                        formData[item.key] = this.verifyInfo[item.key];
                    }
                });
            }
            return formData;
        },
        saveFormToLocal() {
            if (!this.storeLoaded) return;
            localStorage.setItem(`${localStorageKeys.verifyForm}:${this.verifyType}`, JSON.stringify(this.postForm));
        },
        loadFormToLocal() {
            const st = lodash.get(this.openPlatformStatus, 'status', 0);
            const typeFromServer = lodash.get(this.openPlatformStatus, 'type', 0)
            if (typeFromServer != 1 && typeFromServer != 2) {
                this.verifyType = parseInt(localStorage.getItem(localStorageKeys.verifyType) || 1) || 1;
            } else {
                this.verifyType = typeFromServer;
            }
            if (this.verifyType == 2) {
                this.postForm = JSON.parse(JSON.stringify(defaultPersonalVerifyForm));
            } else {
                this.postForm = JSON.parse(JSON.stringify(defaultCompanyVerifyForm));
            }
            const formRaw = localStorage.getItem(`${localStorageKeys.verifyForm}:${this.verifyType}`);
            let formJSON = null;
            if (!formRaw) {
                if (st == 2  || st == 8 || st == 5 || st == 6 || st == 7 || this.updateOnly) {
                    // 尝试从已认证数据中获取
                    formJSON = this.pickVerifyData();
                }
            } else {
                // 本地有数据直接用本地数据
                try {
                    formJSON = JSON.parse(formRaw);
                } catch (e) {}
            }
            if (formJSON) {
                this.postForm = {
                    ...this.postForm,
                    ...formJSON,
                }
            }
            this.$nextTick(() => {
                this.storeLoaded = true;
            })
        },
        selectTime(field) {
            const _timeformat = 'yyyy-MM-dd';
            try{
                const timeSelector = new top.oofUtil.timeSelector({
                    theme:'01',
                    rangeMode:false,
                    autoHide:false,
                    hasTime:false,
                    format: _timeformat,
                    callback:(d) => {
                        this.postForm[field] = d;
                        timeSelector.hideLayer();
                    }
                });
                timeSelector.showLayer(null, '', false);
            }catch(e){
                console.log(e)
            }
        }
    },
    mounted() {
        this.loadFormToLocal()
    },
    filters: {},
    components: {
        UploadImage
    },
    watch: {
        postForm:{
            deep: true,
            handler: function() {
                this.saveFormToLocal()
            }
        },
    }
}
